import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { Notifications, WhiteButton } from 'components';
import { INotificationsData, INotificationsAction } from 'models/notifications/notifications';
import { IStore } from 'redux/IStore';
import {
	getNotifications,
	changeTabAndGetRequiredData,
	resetData,
	notificationView,
} from 'modules/notifications/notificationspage';
import { IUserPreferences } from 'models/user/userpreferences';
import { browserHistory } from 'react-router';
import { IShopCard } from 'models/shop/shopcard';
import { PortalOneColumnLayout, CenteredWiderPortalPage, PageTitle } from 'components/PortalStructure';
const { connect } = require('react-redux');
require('./style.scss');

interface IProps {
	notificationsPage?: INotificationsData;
	userPreferences?: IUserPreferences;

	/* func props */
	t?: (x: string) => string;
	changeTabAndGetRequiredData?: (selectedTab: string) => INotificationsAction;
	getNotifications?: (isFirstLoad: boolean, profileOnly: boolean, shopOnly: boolean) => INotificationsAction;
	resetData?: () => INotificationsAction;
	notificationView?: (notificationIds: string[], viewed?: boolean, viewAll?: boolean) => INotificationsAction;
}

@connect(
	(state: IStore) => ({
		notificationsPage: state.notificationsPage,
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({
		changeTabAndGetRequiredData: (selectedTab: string) => dispatch(changeTabAndGetRequiredData(selectedTab)),
		getNotifications: (isFirstLoad: boolean, profileOnly: boolean, shopOnly: boolean) =>
			dispatch(getNotifications(isFirstLoad, profileOnly, shopOnly)),
		resetData: () => dispatch(resetData()),
		notificationView: (notificationIds: string[], viewed?: boolean, viewAll?: boolean) =>
			dispatch(notificationView(notificationIds, viewed, viewAll)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class NotificationsPage extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.loadMoreNotifications = this.loadMoreNotifications.bind(this);
	}

	public componentWillUnmount() {
		this.props.resetData();
	}

	private loadMoreNotifications() {
		let profileOnly: boolean = false;
		let shopOnly: boolean = false;

		switch (this.props.notificationsPage.selectedTab) {
			case c.NOTIFICATIONS_TAB_USER:
				profileOnly = true;
				break;

			case c.NOTIFICATIONS_TAB_SHOP:
				shopOnly = true;
				break;

			default:
				break;
		}

		this.props.getNotifications(false, profileOnly, shopOnly);
	}

	public render() {
		const { notificationsPage, userPreferences, t } = this.props;

		let shop: IShopCard = null;
		if (userPreferences.userShops && userPreferences.userShops.length > 0) {
			shop = userPreferences.userShops[0];
		}

		return (
			<PortalOneColumnLayout>
				<CenteredWiderPortalPage>
					<PageTitle
						title={t('Notifications_Page_Label_Notifications')}
						titleContent={
							<WhiteButton
								type="button"
								size="small"
								onClick={() => {
									browserHistory.push('notification-settings');
								}}
							>
								{t('Notifications_Page_Button_Settings')}
							</WhiteButton>
						}
					/>
					<div className="notificationsPageContainer">
						<Notifications
							error={notificationsPage.error}
							message={notificationsPage.message}
							selectedTab={notificationsPage.selectedTab}
							items={notificationsPage.items}
							itemsPage={notificationsPage.itemsPage}
							loadMoreNotifications={this.loadMoreNotifications}
							changeTabAndGetRequiredData={this.props.changeTabAndGetRequiredData}
							shop={shop}
							onNotificationClick={(id: string) => {
								this.props.notificationView([id], true, false);
							}}
						/>
					</div>
				</CenteredWiderPortalPage>
			</PortalOneColumnLayout>
		);
	}
}
export { NotificationsPage };
